// {% comment %} ######## customised tyre fitment five ######### {% endcomment %}

(function () {
  const SEP_CLEAN_RE = /[~_]/g;

  // ===============================
  // DEBUG TOGGLES
  // ===============================
  const DEBUG = false;
  const DEBUG_VISIBLE_PRODUCTS = false; // keep console clean

  // ===============================
  // Fixed type list (ALWAYS shown)
  // (per request: remove the word "TYRE" from each entry)
  // ===============================
  const FIXED_TYPE_LIST = [
    "FRONT ADVENTURE",
    "FRONT MOTOCROSS",
    "FRONT TOURING",
    "FRONT ROAD",
    "REAR ADVENTURE",
    "REAR MOTOCROSS",
    "REAR TOURING",
    "REAR ROAD",
    "RACING",
    "ATV",
    "SCOOTER",
    "TRIAL",
    "TUBE"
  ];

  // ===============================
  // Tyre/Tube Brand Allowlist (top-level filter)
  // ===============================
  const TYRE_TUBE_BRANDS_RAW = [
    // Big global moto tyre brands
    "MICHELIN", "BRIDGESTONE", "PIRELLI", "METZELER", "DUNLOP", "CONTINENTAL",
    "AVON", "MITAS", "HEIDENAU", "SHINKO", "IRC", "IRC TIRE",
    "VEE RUBBER", "VEERUBBER", "CST", "CHENG SHIN", "MAXXIS", "KENDA", "DURO", "EUROGRIP",

    // Common moto/off-road brands
    "TRELLEBORG", "ANLAS", "CEAT", "TVS EUROGRIP", "EUROGRIP",
    "TIMSUN", "ZENEOS", "DSI", "DEESTONE", "VIKING", "ROSAVA",
    "SAVA", "VREDESTEIN",

    // Dirt/motocross/enduro focused
    "GOLDENTYRE", "GOLDEN TYRE", "MOTOZ", "MITROC",

    // ATV / UTV / farm tyres (common)
    "BKT", "WANDA", "WANDA TYRES", "CARLISLE", "ITP", "SUNF", "SEDONA",
    "KINGS TIRE", "KINGSTIRE", "TUSK",

    // ATV tyre brands requested
    "FORERUNNER", "AMS", "MAXI GRIP", "ARTRAX"
  ];

  function normalizeBrandKey(s) {
    return String(s || "")
      .toUpperCase()
      .replace(SEP_CLEAN_RE, "-")
      .replace(/[^A-Z0-9]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  // aliases -> canonical keys
  const BRAND_ALIASES = new Map([
    // Continental variants (including your requested "Continenta")
    ["CONTINENTAL TYRES", "CONTINENTAL"],
    ["CONTINENTALTYRES", "CONTINENTAL"],
    ["CONTINENTALTYRE", "CONTINENTAL"],
    ["CONTINENTA", "CONTINENTAL"],

    // Vee Rubber variants
    ["VEE RUBBER", "VEERUBBER"],
    ["VEE-RUBBER", "VEERUBBER"],
    ["VEE RUBBER TUBES", "VEERUBBER"],
    ["VEERUBBERTUBES", "VEERUBBER"],

    // IRC variants
    ["IRC TIRE", "IRC"],

    // SUNF variants (including your requested "Sun F")
    ["SUN F", "SUNF"],

    // Forerunner common misspelling
    ["FOREUNNER", "FORERUNNER"],
    ["FOREUNNER ATV TYRES", "FORERUNNER"],
    ["FORERUNNER ATV TYRES", "FORERUNNER"],

    // Maxxis messy vendor variants
    ["MAXXIS TYRES", "MAXXIS"],
    ["MAXXIS TIRES", "MAXXIS"],
    ["MAXXISTYRES", "MAXXIS"],
    ["MAXXISTIRES", "MAXXIS"],

    // Artrax variants
    ["ARTRAXTYRES", "ARTRAX"],
    ["ARTRAX TYRES", "ARTRAX"],
    ["ARTRAX ATV TYRES", "ARTRAX"],

    // Maxi Grip variants
    ["MAXIGRIP", "MAXI GRIP"],
    ["MAXIGRIP TYRES", "MAXI GRIP"]
  ]);

  function canonicalizeBrandKey(k) {
    const nk = normalizeBrandKey(k);
    if (!nk) return "";

    const mapped = BRAND_ALIASES.get(nk) || nk;
    let out = normalizeBrandKey(mapped);

    // normalize vendor "prefix" junk
    if (out.startsWith("MAXXIS ")) out = "MAXXIS";
    if (out.startsWith("CONTINENTAL ")) out = "CONTINENTAL";
    if (out.startsWith("FORERUNNER ")) out = "FORERUNNER";
    if (out.startsWith("ARTRAX ")) out = "ARTRAX";

    return out;
  }

  const TYRE_TUBE_BRANDS = new Set(
    TYRE_TUBE_BRANDS_RAW.map(canonicalizeBrandKey).filter(Boolean)
  );

  // Prebuild strict regex patterns for allowlisted brand matching (longest first)
  const ALLOWLIST_BRAND_KEYS_SORTED = Array.from(TYRE_TUBE_BRANDS).sort((a, b) => b.length - a.length);

  function brandKeyToBoundaryRegex(brandKey) {
    const escaped = brandKey.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    return new RegExp(`(^|\\s)${escaped}(?=\\s|$)`, "i");
  }

  const ALLOWLIST_BRAND_PATTERNS = ALLOWLIST_BRAND_KEYS_SORTED.map(k => ({
    key: k,
    re: brandKeyToBoundaryRegex(k)
  }));

  // -------------------------------
  // Helpers
  // -------------------------------
  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.from(root.querySelectorAll(sel)); }

  function normalizeText(s) {
    return (s || "")
      .toUpperCase()
      .replace(SEP_CLEAN_RE, "-")
      .replace(/\s+/g, " ")
      .trim();
  }

  function normalizeBrand(s) {
    return String(s || "")
      .replace(/\s+/g, " ")
      .trim()
      .toUpperCase();
  }

  function escapeHtml(str) {
    return String(str || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function getTagArray(tags) {
    if (!tags) return [];
    if (Array.isArray(tags)) return tags.map(t => String(t).trim()).filter(Boolean);
    if (typeof tags === "string") return tags.split(",").map(t => t.trim()).filter(Boolean);
    return [];
  }

  // ignore TYRES&TUBES in tag scanning
  function getTagArrayForScan(tags) {
    return getTagArray(tags).filter(t => {
      const up = normalizeText(t);
      if (up.includes("TYRES&TUBES")) return false;
      return true;
    });
  }

  function uniqSortNumeric(arr) {
    const u = Array.from(new Set(arr));
    return u.sort((a, b) => Number(a) - Number(b));
  }

  // supports string OR {value,label}
  function setOptions(selectEl, values, placeholder) {
    if (!selectEl) return;
    selectEl.innerHTML = "";

    const opt0 = document.createElement("option");
    opt0.value = "";
    opt0.textContent = placeholder;
    selectEl.appendChild(opt0);

    values.forEach(v => {
      const opt = document.createElement("option");
      if (v && typeof v === "object") {
        opt.value = String(v.value ?? "");
        opt.textContent = String(v.label ?? v.value ?? "");
      } else {
        opt.value = String(v);
        opt.textContent = String(v);
      }
      selectEl.appendChild(opt);
    });
  }

  function normIntString(s) {
    const n = parseInt(String(s), 10);
    if (Number.isNaN(n)) return String(s);
    return String(n);
  }

  function normInchWidth(s) {
    const n = Number(String(s));
    if (Number.isNaN(n)) return String(s);
    const isInt = Math.abs(n - Math.round(n)) < 1e-9;
    return isInt ? String(Math.round(n)) : String(parseFloat(n.toFixed(2)));
  }

  // -------------------------------
  // Brand extraction
  // -------------------------------
  function extractBrandFromTags(tags) {
    const arr = getTagArrayForScan(tags);

    for (const raw of arr) {
      const t = String(raw || "").trim();
      if (/^brand_/i.test(t)) return t.replace(/^brand_/i, "").trim();
      if (/^brand-/i.test(t)) return t.replace(/^brand-/i, "").trim();
      if (/^s3-brand-/i.test(t)) return t.replace(/^s3-brand-/i, "").trim();
    }
    return "";
  }

  function cleanupBrand(brandUpper) {
    let b = normalizeBrand(brandUpper);

    if (b === "FORZA HUB") return "";

    if (b === "SUN F") b = "SUNF";
    if (b === "CONTINENTA") b = "CONTINENTAL";

    if (b === "CONTINENTALTYRES") b = "CONTINENTAL";
    if (b === "CONTINENTAL TYRES") b = "CONTINENTAL";
    if (b === "CONTINENTALTYRE") b = "CONTINENTAL";

    if (b === "VEE RUBBER") b = "VEERUBBER";
    if (b === "VEE-RUBBER") b = "VEERUBBER";
    if (b.replace(/\s+/g, "") === "VEERUBBER") b = "VEERUBBER";

    if (b === "VEERUBBERTUBES") b = "VEERUBBER";
    if (b === "VEE RUBBER TUBES") b = "VEERUBBER";

    if (b.startsWith("MAXXIS ")) b = "MAXXIS";
    if (b === "MAXXISTYRES" || b === "MAXXISTIRES" || b === "MAXXIS TYRES" || b === "MAXXIS TIRES") b = "MAXXIS";

    if (b.startsWith("FOREUNNER")) b = b.replace(/^FOREUNNER/, "FORERUNNER");
    if (b.startsWith("FORERUNNER ")) b = "FORERUNNER";

    if (b.startsWith("ARTRAX ")) b = "ARTRAX";

    return b;
  }

  function prettyBrandLabel(brandKey) {
    const b = cleanupBrand(brandKey);
    if (b === "VEERUBBER") return "VEE RUBBER";
    return b;
  }

  // -------------------------------
  // Strict allowlist brand detection
  // -------------------------------
  function extractBrandFromTagsForAllowlist(tags) {
    const arr = getTagArrayForScan(tags);

    for (const raw of arr) {
      const t = String(raw || "").trim();
      if (/^brand_/i.test(t)) return t.replace(/^brand_/i, "").trim();
      if (/^brand-/i.test(t)) return t.replace(/^brand-/i, "").trim();
      if (/^s3-brand-/i.test(t)) return t.replace(/^s3-brand-/i, "").trim();
      if (/^s3-brand_/i.test(t)) return t.replace(/^s3-brand_/i, "").trim();
    }
    return "";
  }

  function findAllowlistedBrandInTextStrict(text) {
    const norm = canonicalizeBrandKey(text);
    if (!norm) return "";

    if (TYRE_TUBE_BRANDS.has(norm)) return norm;

    for (const { key, re } of ALLOWLIST_BRAND_PATTERNS) {
      if (re.test(norm)) return key;
    }
    return "";
  }

  function getAllowlistedBrand(product) {
    const title = String(product?.title || "");
    const vendor = String(product?.vendor || "");
    const tags = getTagArrayForScan(product?.tags);

    // ignore product_type "Artrax ATV Tyres" when detecting brand (category-ish)
    let ptype = String(product?.product_type || "");
    if (normalizeText(ptype) === "ARTRAX ATV TYRES") ptype = "";

    const variants = Array.isArray(product?.variants) ? product.variants : [];
    const variantTitles = variants.map(v => String(v?.title || "")).join(" ");

    // 1) explicit BRAND tag
    const fromTag = extractBrandFromTagsForAllowlist(tags);
    const c1 = findAllowlistedBrandInTextStrict(fromTag);
    if (c1) return c1;

    // 2) vendor
    const c2 = findAllowlistedBrandInTextStrict(vendor);
    if (c2) return c2;

    // 3) core fields
    const core = [ptype, title, variantTitles].join(" ");
    const c3 = findAllowlistedBrandInTextStrict(core);
    if (c3) return c3;

    // 4) tags only if tag exactly equals a brand key
    for (const t of tags) {
      const ct = findAllowlistedBrandInTextStrict(t);
      if (ct && canonicalizeBrandKey(t) === ct) return ct;
    }

    return "";
  }

  function getProductBrand(product) {
    const allow = getAllowlistedBrand(product);
    if (allow) return cleanupBrand(allow);

    const fromTag = extractBrandFromTags(product.tags);
    const fromVendor = String(product.vendor || "").trim();
    const raw = (fromTag || fromVendor).trim();
    return cleanupBrand(raw);
  }

  // -------------------------------
  // Tyre + Tube only filter (+ exclude OKO sealant)
  // + BRAND allowlist as TOP-LEVEL filter
  // -------------------------------
  function isTyreOrTubeProduct(product) {
    const title = String(product?.title || "");
    const ptype = String(product?.product_type || "");
    const vendor = String(product?.vendor || "");
    const tagsArr = getTagArrayForScan(product?.tags);

    const titleUpper = title.toUpperCase();
    const typeUpper = ptype.toUpperCase();
    const vendorUpper = vendor.toUpperCase().trim();

    if (vendorUpper === "OKO") return false;
    if (titleUpper.includes("SEALANT")) return false;
    if (typeUpper.includes("SEALANT")) return false;

    const allowBrand = getAllowlistedBrand(product);
    if (!allowBrand) return false;

    const hay = `${title} ${ptype} ${vendor} ${tagsArr.join(" ")}`.toLowerCase();

    const hasTyreWord = /\btyre\b|\btyres\b|\btire\b|\btires\b/.test(hay);
    const hasTubeWord = /\btube\b|\btubes\b|\binner\s*tube\b|\binner\s*tubes\b/.test(hay);

    const hasMetricSize =
      /(^|[^0-9])(\d{2,3})\s*\/\s*(\d{2})\s*([a-z]{0,4})\s*(z?r)?\s*[-\s]*?(\d{2})(?!\d)/i.test(hay) ||
      /(^|[^0-9])(\d{2,3})\s*-\s*(\d{2})\s*(?:-\s*[a-z]{1,3}\s*)?-\s*(\d{2})(?!\d)/i.test(hay);

    const hasInchSize = /(^|[^0-9])(\d{1,2}(?:\.\d{1,2})?)\s*-\s*(\d{1,2})(?!\d)/i.test(hay);

    const hasAtvSize =
      /\b\d{2}\s*[xX]\s*\d{1,2}\s*[xX]\s*\d{2}\b/.test(hay) ||
      /\b\d{2}\s*[xX]\s*\d{1,2}\s*-\s*\d{2}\b/.test(hay);

    return hasTyreWord || hasTubeWord || hasMetricSize || hasInchSize || hasAtvSize;
  }

  // -------------------------------
  // Size parsing
  // -------------------------------
  function extractMetric(text) {
    const out = [];
    const re1 = /(^|[^0-9])(\d{2,3})\s*\/\s*(\d{2})\s*([A-Z]{0,4})\s*(Z?R)?\s*[-\s]*?(\d{2})(?!\d)/g;
    const re2 = /(^|[^0-9])(\d{2,3})\s*-\s*(\d{2})\s*(?:-\s*[A-Z]{1,3}\s*)?-\s*(\d{2})(?!\d)/g;

    let m;
    while ((m = re1.exec(text)) !== null) {
      const width = parseInt(m[2], 10);
      const ratio = parseInt(m[3], 10);
      const rim = parseInt(m[6], 10);
      if (width >= 50 && width <= 300 && ratio >= 20 && ratio <= 95 && rim >= 8 && rim <= 30) {
        out.push({ system: "metric", width: String(width), ratio: String(ratio), rim: String(rim) });
      }
    }

    while ((m = re2.exec(text)) !== null) {
      const width = parseInt(m[2], 10);
      const ratio = parseInt(m[3], 10);
      const rim = parseInt(m[4], 10);
      if (width >= 50 && width <= 300 && ratio >= 20 && ratio <= 95 && rim >= 8 && rim <= 30) {
        out.push({ system: "metric", width: String(width), ratio: String(ratio), rim: String(rim) });
      }
    }
    return out;
  }

  function extractInch(text) {
    const out = [];
    const re = /(^|[^0-9])(\d{1,2}(?:\.\d{1,2})?)\s*-\s*(\d{1,2})(?!\d)/g;

    let m;
    while ((m = re.exec(text)) !== null) {
      const idx = m.index;
      const windowBefore = text.slice(Math.max(0, idx - 6), idx);
      if (windowBefore.includes("/")) continue;

      const widthNum = Number(m[2]);
      const rimNum = Number(m[3]);
      if (!(widthNum > 0 && widthNum <= 15)) continue;
      if (!(rimNum >= 8 && rimNum <= 30)) continue;

      out.push({ system: "inch", width: normInchWidth(m[2]), rim: String(parseInt(m[3], 10)) });
    }
    return out;
  }

  function extractAtv(text) {
    const out = [];

    const reXXX = /(^|[^0-9])(\d{2})\s*[Xx]\s*(\d{1,2})\s*[Xx]\s*(\d{2})(?!\d)/g;
    const reXDash = /(^|[^0-9])(\d{2})\s*[Xx]\s*(\d{1,2})\s*-\s*(\d{2})(?!\d)/g;

    let m;
    while ((m = reXXX.exec(text)) !== null) {
      const overall = parseInt(m[2], 10);
      const width = parseInt(m[3], 10);
      const rim = parseInt(m[4], 10);

      if (overall < 18 || overall > 40) continue;
      if (width < 6 || width > 15) continue;
      if (rim < 8 || rim > 20) continue;

      out.push({ system: "inch", width: String(width), rim: String(rim) });
    }

    while ((m = reXDash.exec(text)) !== null) {
      const overall = parseInt(m[2], 10);
      const width = parseInt(m[3], 10);
      const rim = parseInt(m[4], 10);

      if (overall < 18 || overall > 40) continue;
      if (width < 6 || width > 15) continue;
      if (rim < 8 || rim > 20) continue;

      out.push({ system: "inch", width: String(width), rim: String(rim) });
    }

    return out;
  }

  function dedupeSizes(sizes) {
    const seen = new Set();
    const out = [];
    for (const s of sizes) {
      const k = s.system === "metric"
        ? `m|${s.width}|${s.ratio}|${s.rim}`
        : `i|${s.width}||${s.rim}`;
      if (!seen.has(k)) { seen.add(k); out.push(s); }
    }
    return out;
  }

  function extractSizesFromProduct(product) {
    const parts = [];
    parts.push(product.title || "");
    parts.push(product.product_type || "");
    getTagArrayForScan(product.tags).forEach(t => parts.push(t));
    const variants = Array.isArray(product.variants) ? product.variants : [];
    variants.forEach(v => parts.push((v && v.title) ? v.title : ""));

    const src = normalizeText(parts.join(" "));
    return dedupeSizes([...extractMetric(src), ...extractInch(src), ...extractAtv(src)]);
  }

  // -------------------------------
  // Product Type Classification
  // -------------------------------
  function classifyProductType(product) {
    const title = String(product?.title || "");
    const ptype = String(product?.product_type || "");
    const vendor = String(product?.vendor || "");

    const tags = getTagArrayForScan(product?.tags);
    const variants = Array.isArray(product?.variants) ? product.variants : [];
    const variantTitles = variants.map(v => String(v?.title || "")).join(" ");

    const hayCoreUpper = normalizeText([title, ptype, vendor, variantTitles].join(" "));
    const tagSetUpper = new Set(tags.map(t => normalizeText(t)));
    const vendorUpper = normalizeBrand(product?.vendor);

    const allowBrand = getAllowlistedBrand(product);

    const hasTyreCore =
      /\bTYRE\b|\bTYRES\b|\bTIRE\b|\bTIRES\b/i.test(hayCoreUpper);

    // TUBE
    const tubeInCore =
      /\bINNER\s*TUBE(S)?\b/i.test(hayCoreUpper) ||
      /\bTUBE(S)?\b/i.test(hayCoreUpper);

    const tubeTagExact =
      tagSetUpper.has("TUBE") ||
      tagSetUpper.has("INNER TUBE") ||
      tagSetUpper.has("INNER TUBES");

    if ((tubeInCore || tubeTagExact) && !hasTyreCore) {
      return "TUBE";
    }

    // SUNF rule: MX/Enduro => not ATV
    const sunfNotAtvBecauseMxOrEnduro =
      allowBrand === "SUNF" && (/\bMX\b/i.test(hayCoreUpper) || /\bMOTOCROSS\b/i.test(hayCoreUpper) || /\bENDURO\b/i.test(hayCoreUpper));

    // ARTRAX rule: MX/Enduro => not ATV
    const artraxNotAtvBecauseMxOrEnduro =
      allowBrand === "ARTRAX" && (/\bMX\b/i.test(hayCoreUpper) || /\bMOTOCROSS\b/i.test(hayCoreUpper) || /\bENDURO\b/i.test(hayCoreUpper));

    // ATV logic
    const atvInCore = /\bATV\b/i.test(hayCoreUpper);

    const atvTagExact =
      tagSetUpper.has("ATV") ||
      tags.some(t => String(t || "").trim().toUpperCase() === "ATV");

    const hasExplicitAtvTyreTag = (() => {
      for (const rawTag of tags) {
        const raw = String(rawTag || "").trim();
        const up = raw.toUpperCase();

        if (up.includes("&ATV") || up.includes("/ATV") || up.includes("ATV&") || up.includes("ATV/")) continue;
        if (!/\bATV\b/.test(up) && up.includes("ATV")) continue;

        if (up === "ATV TYRE" || up === "ATV TYRES" || up === "ATVTYRE" || up === "ATVTYRES") return true;
        if (/\bATV\b/.test(up) && /\bTYRE(S)?\b/.test(up)) return true;
      }
      return false;
    })();

    if (!sunfNotAtvBecauseMxOrEnduro && !artraxNotAtvBecauseMxOrEnduro && vendorUpper !== "MITROC") {
      if (atvInCore || atvTagExact || hasExplicitAtvTyreTag) {
        return "ATV";
      }
    }

    // Scooter / Trial
    if (/\bSCOOTER\b/i.test(hayCoreUpper) || tagSetUpper.has("SCOOTER")) return "SCOOTER";
    if (/\bTRIAL\b/i.test(hayCoreUpper) || tagSetUpper.has("TRIAL")) return "TRIAL";

    // Racing
    const isRacing =
      /\bRACE\b|\bRACING\b|\bRACER\b|\bTRACK\b|\bTRACKDAY\b|\bCIRCUIT\b|\bSLICK\b/i.test(hayCoreUpper) ||
      tagSetUpper.has("RACE") ||
      tagSetUpper.has("RACING");

    if (isRacing) return "RACING";

    // Front/Rear + categories
    const isFront =
      /\bFRONT\b/i.test(hayCoreUpper) ||
      tagSetUpper.has("FRONT") ||
      [...tagSetUpper].some(t => String(t).includes("FRONT"));

    const isRear =
      /\bREAR\b/i.test(hayCoreUpper) ||
      tagSetUpper.has("REAR") ||
      [...tagSetUpper].some(t => String(t).includes("REAR"));

    const isMoto =
      /\bMOTOCROSS\b|\bMX\b/i.test(hayCoreUpper) ||
      tagSetUpper.has("MOTOCROSS") ||
      tagSetUpper.has("MX");

    const isAdventure =
      /\bADVENTURE\b|\bADV\b|\bDUAL\s*SPORT\b|\bENDURO\b/i.test(hayCoreUpper) ||
      tagSetUpper.has("ADVENTURE") ||
      tagSetUpper.has("ADV") ||
      [...tagSetUpper].some(t => t.includes("RIDESTYLE_ADVENTURE"));

    const isTouring =
      /\bTOURING\b|\bTOUR\b/i.test(hayCoreUpper) ||
      tagSetUpper.has("TOURING") ||
      tagSetUpper.has("TOUR") ||
      [...tagSetUpper].some(t => t.includes("TOURING"));

    const isRoad =
      /\bROAD\b|\bSTREET\b|\bURBAN\b|\bCOMMUTER\b/i.test(hayCoreUpper) ||
      tagSetUpper.has("ROAD") ||
      tagSetUpper.has("STREET") ||
      tagSetUpper.has("URBAN") ||
      tagSetUpper.has("COMMUTER");

    if (isFront) {
      if (isMoto) return "FRONT MOTOCROSS";
      if (isAdventure) return "FRONT ADVENTURE";
      if (isTouring) return "FRONT TOURING";
      if (isRoad) return "FRONT ROAD";
      return "FRONT ROAD";
    }

    if (isRear) {
      if (isMoto) return "REAR MOTOCROSS";
      if (isAdventure) return "REAR ADVENTURE";
      if (isTouring) return "REAR TOURING";
      if (isRoad) return "REAR ROAD";
      return "REAR ROAD";
    }

    if (isMoto) return "REAR MOTOCROSS";
    if (isAdventure) return "REAR ADVENTURE";
    if (isTouring) return "REAR TOURING";
    if (isRoad) return "REAR ROAD";

    return "REAR ROAD";
  }

  // -------------------------------
  // Price + card (Superstore product-grid-item style)
  // -------------------------------
  function getBestVariant(product) {
    const variants = Array.isArray(product?.variants) ? product.variants : [];
    if (!variants.length) return null;
    const available = variants.find(v => v && (v.available === true || v.available === "true"));
    return available || variants[0];
  }

  function toCentsFromMoneyString(v) {
    if (v == null) return null;
    const num = Number(String(v).replace(/[^0-9.]/g, ""));
    if (Number.isNaN(num)) return null;
    return Math.round(num * 100);
  }

  function formatMoneyFromCents(cents, moneyFormat) {
    const fmt = moneyFormat || "${{amount}}";
    if (cents == null || Number.isNaN(Number(cents))) return "";
    const amount = (cents / 100).toFixed(2);

    return fmt
      .replace("{{amount_no_decimals}}", String(Math.round(cents / 100)))
      .replace("{{amount}}", amount)
      .replace("{{amount_with_comma_separator}}", amount.replace(".", ","))
      .replace("{{amount_no_decimals_with_comma_separator}}", String(Math.round(cents / 100)).replace(".", ","));
  }

  function productUrl(p) {
    if (p?.url) return p.url;
    if (p?.handle) return `/products/${p.handle}`;
    return "#";
  }

  function productImage(product) {
    if (typeof product?.featured_image === "string" && product.featured_image) return product.featured_image;
    if (Array.isArray(product?.images) && product.images.length) return product.images[0];
    return "";
  }

  function renderCard(product, moneyFormat) {
    const v = getBestVariant(product);
    const available = v ? (v.available === true || v.available === "true") : true;

    const priceCents = v ? toCentsFromMoneyString(v.price) : null;
    const compareCents = v && v.compare_at_price != null ? toCentsFromMoneyString(v.compare_at_price) : null;
    const onSale = compareCents != null && priceCents != null && compareCents > priceCents;

    const img1 = productImage(product);
    const img2 = Array.isArray(product?.images) && product.images.length > 1 ? product.images[1] : "";

    const imgPrimaryHtml = img1
      ? `<img class="productitem--image-primary" loading="lazy" src="${img1}" alt="${escapeHtml(product.title)}">`
      : "";

    const imgAltHtml = img2
      ? `<img class="productitem--image-alternate" loading="lazy" src="${img2}" alt="">`
      : "";

    const priceHtml = (priceCents != null)
      ? `
        <div class="productitem--price product-price">
          ${onSale ? `<s class="product-price--compare"><span class="money">${escapeHtml(formatMoneyFromCents(compareCents, moneyFormat))}</span></s>` : ""}
          <span class="product-price--final"><span class="money">${escapeHtml(formatMoneyFromCents(priceCents, moneyFormat))}</span></span>
        </div>
      `
      : "";

    const badgeHtml = (!available)
      ? `<span class="productitem--badge productitem--badge-soldout">Sold out</span>`
      : (onSale ? `<span class="productitem--badge productitem--badge-sale">Sale</span>` : "");

    return `
      <article class="productitem" data-product-item-content>
        <a
          class="productitem--image-link"
          href="${productUrl(product)}"
          tabindex="-1"
          data-product-page-link
        >
          <figure class="productitem--image" data-product-item-image>
            ${imgAltHtml}
            ${imgPrimaryHtml}
            ${badgeHtml}
          </figure>
        </a>

        <div class="productitem--info">
          ${product.vendor ? `<span class="productitem--vendor">${escapeHtml(product.vendor)}</span>` : ""}

          <h2 class="productitem--title">
            <a href="${productUrl(product)}" data-product-page-link>
              ${escapeHtml(product.title)}
            </a>
          </h2>

          ${priceHtml}
        </div>
      </article>
    `;
  }

  function getFirstVariantPriceCents(product) {
    const v = getBestVariant(product);
    if (!v) return null;
    return toCentsFromMoneyString(v.price);
  }

  // -------------------------------
  // Fetch products from view JSON
  // -------------------------------
  async function fetchAllCollectionProductsViaView(handle, loadingEl, countEl) {
    const all = [];
    let page = 1;
    let pages = 1;

    while (page <= pages) {
      if (loadingEl) {
        loadingEl.hidden = false;
        const t = loadingEl.querySelector(".tyre-fitment__loading-text");
        if (t) t.textContent = `Loading… (${all.length})`;
      }
      if (countEl) {
        countEl.textContent = `${all.length}/${all.length}`;
        countEl.classList.add("is-loading");
      }

      const url = `/collections/${handle}?view=tyre-fitment-json&page=${page}`;
      const res = await fetch(url, { cache: "no-store" });
      if (!res.ok) break;

      const data = await res.json();
      pages = Number(data.pages || 1);
      const products = Array.isArray(data.products) ? data.products : [];
      all.push(...products); // ✅ fixed

      page += 1;
      if (page > 50) break; // safety
    }

    return all;
  }

  // -------------------------------
  // Build maps
  // -------------------------------
  function buildMaps(products) {
    const metricWidthToRatios = new Map();
    const metricWRToRims = new Map();
    const inchWidthToRims = new Map();

    const productSizes = new Map();
    const usableProducts = [];

    for (const p of products) {
      if (!isTyreOrTubeProduct(p)) continue;

      const sizes = extractSizesFromProduct(p);
      productSizes.set(p.id, sizes);
      if (!sizes.length) continue;

      usableProducts.push(p);

      for (const s of sizes) {
        if (s.system === "metric") {
          if (!metricWidthToRatios.has(s.width)) metricWidthToRatios.set(s.width, new Set());
          metricWidthToRatios.get(s.width).add(s.ratio);

          const wr = `${s.width}|${s.ratio}`;
          if (!metricWRToRims.has(wr)) metricWRToRims.set(wr, new Set());
          metricWRToRims.get(wr).add(s.rim);
        } else {
          if (!inchWidthToRims.has(s.width)) inchWidthToRims.set(s.width, new Set());
          inchWidthToRims.get(s.width).add(s.rim);
        }
      }
    }

    return { metricWidthToRatios, metricWRToRims, inchWidthToRims, productSizes, usableProducts };
  }

  // -------------------------------
  // Init
  // -------------------------------
  function boot() {
    qsa(document, ".tyre-fitment").forEach(init);
  }

  async function init(sectionEl) {
    const handle = sectionEl.getAttribute("data-collection-handle");
    const moneyFormat = sectionEl.getAttribute("data-money-format") || "${{amount}}";

    const widthSel = qs(sectionEl, "[data-fitment-width]");
    const ratioSel = qs(sectionEl, "[data-fitment-ratio]");
    const ratioWrap = qs(sectionEl, "[data-fitment-ratio-wrap]");
    const rimSel = qs(sectionEl, "[data-fitment-rim]");
    const searchBtn = qs(sectionEl, "[data-fitment-search]");
    const resetBtn = qs(sectionEl, "[data-fitment-reset]");
    const countEl = qs(sectionEl, "[data-fitment-count]");
    const loadingEl = qs(sectionEl, "[data-fitment-loading]");
    const productsWrap = qs(sectionEl, "[data-fitment-products]");
    const emptyEl = qs(sectionEl, "[data-fitment-empty]");
    const form = qs(sectionEl, "form");

    const filtersResetBtn = qs(sectionEl, "[data-fitment-filters-reset]");
    const filtersApplyBtn = qs(sectionEl, "[data-fitment-filters-apply]");
    const brandSel = qs(sectionEl, "[data-fitment-brand]");
    const typeSel = qs(sectionEl, "[data-fitment-type]");
    const priceMinEl = qs(sectionEl, "[data-fitment-price-min]");
    const priceMaxEl = qs(sectionEl, "[data-fitment-price-max]");
    const sortSel = qs(sectionEl, "[data-fitment-sort]");

    if (!handle) return;

    // lock UI while loading
    if (widthSel) widthSel.disabled = true;
    if (ratioSel) ratioSel.disabled = true;
    if (rimSel) rimSel.disabled = true;
    if (searchBtn) searchBtn.disabled = true;
    if (filtersApplyBtn) filtersApplyBtn.disabled = true;

    const allProducts = await fetchAllCollectionProductsViaView(handle, loadingEl, countEl);
    const tyreTubeProducts = allProducts.filter(p => isTyreOrTubeProduct(p));

    // Brands
    const brandsRaw = Array.from(new Set(
      tyreTubeProducts.map(p => getProductBrand(p)).filter(Boolean)
    ));

    const brandOptions = brandsRaw
      .map(v => ({ value: v, label: prettyBrandLabel(v) }))
      .sort((a, b) => a.label.localeCompare(b.label));

    if (brandSel) setOptions(brandSel, brandOptions, "All brands");

    // Product type dropdown: ALWAYS your fixed list
    if (typeSel) setOptions(typeSel, FIXED_TYPE_LIST, "All types");

    const { metricWidthToRatios, metricWRToRims, inchWidthToRims, productSizes, usableProducts } = buildMaps(allProducts);
    const totalCount = usableProducts.length;

    function setCount(matched) {
      if (countEl) countEl.textContent = `${matched}/${totalCount}`;
    }

    let currentFitment = null;
    let currentFilters = { brand: "", type: "", min: null, max: null };
    let currentSort = "featured";

    function renderProducts(list) {
      productsWrap.innerHTML = list.map(p => renderCard(p, moneyFormat)).join("");
      emptyEl.hidden = list.length !== 0;
      setCount(list.length);

      if (DEBUG_VISIBLE_PRODUCTS) {
        console.group("VISIBLE PRODUCTS (" + list.length + ")");
        list.forEach(p => {
          const inferredType = classifyProductType(p);
          console.log({
            title: p.title,
            vendor: p.vendor,
            product_type: p.product_type,
            inferredType,
            allowBrand: getAllowlistedBrand(p),
            tags: getTagArrayForScan(p.tags)
          });
        });
        console.groupEnd();
      }
    }

    function widthValue(system, width) { return `${system}|${width}`; }
    function parseWidthValue(v) {
      const [system, width] = String(v).split("|");
      return { system, width };
    }

    const metricWidths = uniqSortNumeric(Array.from(metricWidthToRatios.keys()).map(normIntString));
    const inchWidths = uniqSortNumeric(Array.from(inchWidthToRims.keys()).map(normInchWidth));

    function setWidthOptions() {
      widthSel.innerHTML = `<option value="">Select Width</option>`;

      if (metricWidths.length) {
        const og = document.createElement("optgroup");
        og.label = "Metric";
        metricWidths.forEach(w => {
          const opt = document.createElement("option");
          opt.value = widthValue("m", w);
          opt.textContent = w;
          og.appendChild(opt);
        });
        widthSel.appendChild(og);
      }

      if (inchWidths.length) {
        const og = document.createElement("optgroup");
        og.label = "Inch";
        inchWidths.forEach(w => {
          const opt = document.createElement("option");
          opt.value = widthValue("i", w);
          opt.textContent = w;
          og.appendChild(opt);
        });
        widthSel.appendChild(og);
      }
    }

    function filterByFitment(products) {
      if (!currentFitment) return products;
      const f = currentFitment;

      return products.filter(p => {
        const sizes = productSizes.get(p.id) || [];
        return sizes.some(s => {
          if (f.system === "m" && s.system === "metric") return s.width === f.width && s.ratio === f.ratio && s.rim === f.rim;
          if (f.system === "i" && s.system === "inch") return s.width === f.width && s.rim === f.rim;
          return false;
        });
      });
    }

    function readFiltersFromUI() {
      const brand = brandSel ? brandSel.value : "";
      const type = typeSel ? typeSel.value : "";
      const min = priceMinEl && priceMinEl.value !== "" ? Number(priceMinEl.value) : null;
      const max = priceMaxEl && priceMaxEl.value !== "" ? Number(priceMaxEl.value) : null;

      currentFilters = {
        brand,
        type,
        min: (min != null && !Number.isNaN(min)) ? min : null,
        max: (max != null && !Number.isNaN(max)) ? max : null
      };
    }

    function filterByFacets(products) {
      let out = products;

      if (currentFilters.brand) {
        const want = cleanupBrand(currentFilters.brand);
        out = out.filter(p => getProductBrand(p) === want);
      }

      if (currentFilters.type) {
        out = out.filter(p => classifyProductType(p) === currentFilters.type);
      }

      const min = currentFilters.min;
      const max = currentFilters.max;

      if (min != null || max != null) {
        out = out.filter(p => {
          const cents = getFirstVariantPriceCents(p);
          if (cents == null) return false;
          const dollars = cents / 100;
          if (min != null && dollars < min) return false;
          if (max != null && dollars > max) return false;
          return true;
        });
      }

      return out;
    }

    function sortProducts(products) {
      const key = currentSort || "featured";
      const arr = [...products]; // ✅ fixed

      if (key === "alpha_asc") arr.sort((a, b) => (a.title || "").localeCompare(b.title || ""));
      else if (key === "alpha_desc") arr.sort((a, b) => (b.title || "").localeCompare(a.title || ""));
      else if (key === "price_asc") arr.sort((a, b) => (getFirstVariantPriceCents(a) ?? 9e18) - (getFirstVariantPriceCents(b) ?? 9e18));
      else if (key === "price_desc") arr.sort((a, b) => (getFirstVariantPriceCents(b) ?? -1) - (getFirstVariantPriceCents(a) ?? -1));
      else if (key === "date_asc") arr.sort((a, b) => new Date(a.published_at || a.created_at || 0) - new Date(b.published_at || b.created_at || 0));
      else if (key === "date_desc") arr.sort((a, b) => new Date(b.published_at || b.created_at || 0) - new Date(a.published_at || a.created_at || 0));

      return arr;
    }

    function recomputeAndRender() {
      const fit = filterByFitment(usableProducts);
      const fac = filterByFacets(fit);
      const sorted = sortProducts(fac);
      renderProducts(sorted);
    }

    function syncSearchButton() {
      const wv = widthSel.value;
      if (!wv) { searchBtn.disabled = true; return; }
      const { system } = parseWidthValue(wv);

      if (system === "i") searchBtn.disabled = !rimSel.value;
      else searchBtn.disabled = !(ratioSel.value && rimSel.value);
    }

    function resetAllFitment() {
      widthSel.value = "";
      ratioSel.value = "";
      rimSel.value = "";
      ratioSel.disabled = true;
      rimSel.disabled = true;
      resetBtn.hidden = true;
      if (ratioWrap) ratioWrap.classList.remove("tyre-fitment__hidden");
      currentFitment = null;
      syncSearchButton();
      recomputeAndRender();
    }

    function updateForWidth() {
      const wv = widthSel.value;
      ratioSel.value = "";
      rimSel.value = "";

      if (!wv) { resetAllFitment(); return; }

      resetBtn.hidden = false;
      const { system, width } = parseWidthValue(wv);
      currentFitment = null;

      if (system === "i") {
        if (ratioWrap) ratioWrap.classList.add("tyre-fitment__hidden");
        ratioSel.disabled = true;

        const rims = uniqSortNumeric(Array.from(inchWidthToRims.get(width) || []).map(normIntString));
        setOptions(rimSel, rims, "Select Wheel Size");
        rimSel.disabled = false;
      } else {
        if (ratioWrap) ratioWrap.classList.remove("tyre-fitment__hidden");

        const ratios = uniqSortNumeric(Array.from(metricWidthToRatios.get(width) || []).map(normIntString));
        setOptions(ratioSel, ratios, "Select Aspect Ratio (Profile)");
        ratioSel.disabled = false;

        setOptions(rimSel, [], "Select Wheel Size");
        rimSel.disabled = true;
      }

      syncSearchButton();
    }

    function updateForRatio() {
      const wv = widthSel.value;
      if (!wv) return;

      const { system, width } = parseWidthValue(wv);
      if (system !== "m") return;

      const ratio = ratioSel.value;
      rimSel.value = "";

      if (!ratio) {
        setOptions(rimSel, [], "Select Wheel Size");
        rimSel.disabled = true;
        syncSearchButton();
        return;
      }

      const rims = uniqSortNumeric(Array.from(metricWRToRims.get(`${width}|${ratio}`) || []).map(normIntString));
      setOptions(rimSel, rims, "Select Wheel Size");
      rimSel.disabled = false;

      syncSearchButton();
    }

    function updateForRim() {
      syncSearchButton();
    }

    let filtersDirty = false;
    function markFiltersDirty() {
      filtersDirty = true;
      if (filtersApplyBtn) filtersApplyBtn.disabled = false;
    }

    if (brandSel) brandSel.addEventListener("change", markFiltersDirty);
    if (typeSel) typeSel.addEventListener("change", markFiltersDirty);
    if (priceMinEl) priceMinEl.addEventListener("input", markFiltersDirty);
    if (priceMaxEl) priceMaxEl.addEventListener("input", markFiltersDirty);

    if (filtersApplyBtn) {
      filtersApplyBtn.addEventListener("click", () => {
        readFiltersFromUI();
        recomputeAndRender();
        filtersDirty = false;
        filtersApplyBtn.disabled = true;
      });
    }

    if (filtersResetBtn) {
      filtersResetBtn.addEventListener("click", () => {
        if (brandSel) brandSel.value = "";
        if (typeSel) typeSel.value = "";
        if (priceMinEl) priceMinEl.value = "";
        if (priceMaxEl) priceMaxEl.value = "";

        readFiltersFromUI();
        recomputeAndRender();

        filtersDirty = false;
        if (filtersApplyBtn) filtersApplyBtn.disabled = true;
      });
    }

    // init UI + render
    setWidthOptions();
    readFiltersFromUI();
    currentSort = (sortSel && sortSel.value) ? sortSel.value : "featured";
    recomputeAndRender();
    setCount(totalCount);

    // unlock UI after load
    if (loadingEl) {
      loadingEl.hidden = true;
      loadingEl.classList.add("is-hidden");
      loadingEl.style.display = "none";
    }
    if (countEl) countEl.classList.remove("is-loading");
    if (widthSel) widthSel.disabled = false;

    syncSearchButton();

    widthSel.addEventListener("change", updateForWidth);
    ratioSel.addEventListener("change", updateForRatio);
    rimSel.addEventListener("change", updateForRim);

    if (sortSel) {
      sortSel.addEventListener("change", () => {
        currentSort = sortSel.value || "featured";
        recomputeAndRender();
      });
    }

    form.addEventListener("submit", (e) => {
      e.preventDefault();

      const wv = widthSel.value;
      if (!wv) return;

      const { system, width } = parseWidthValue(wv);

      if (system === "i") {
        const rim = rimSel.value;
        if (!rim) return;
        currentFitment = { system: "i", width, rim };
      } else {
        const ratio = ratioSel.value;
        const rim = rimSel.value;
        if (!(ratio && rim)) return;
        currentFitment = { system: "m", width, ratio, rim };
      }

      recomputeAndRender();
      (qs(sectionEl, "[data-fitment-grid]") || sectionEl).scrollIntoView({ behavior: "smooth", block: "start" });
    });

    if (resetBtn) resetBtn.addEventListener("click", resetAllFitment);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();

// {% comment %} ######## customised end ######### {% endcomment %}  
